/* eslint-disable react/no-children-prop */
import React, { useState } from "react";
import { Wrapper, Label } from "./styled";
import CommonInput from "components/commons/Inputs/CommonInput";
import colors from "styles/colors";
import useResize from "hooks/useResize";

const PasswordInput = ({ val, setNewUser, newUser, disabled, placeholder }) => {
  const { screenWidth } = useResize();
  const height = screenWidth <= 905 ? "40px" : "48px";

  const [error, setError] = useState(false);
  const errorMessage = error ? "La contraseña ingresa es inválida" : "";

  const onChange = (e) => {
    if (!/^.{6,}$/.test(e.target.value)) setError(true);
    else setError(false);
    setNewUser({ ...newUser, [e.target.name]: e.target.value });
  };

  return (
    <Wrapper>
      <Label children="Contraseña" />
      <CommonInput
        type="password"
        name="password"
        errorMessage={errorMessage}
        error={error}
        height={height}
        onChange={(e) => onChange(e)}
        value={val}
        disabled={disabled}
        placeholder={placeholder}
        color={colors.gray10}
        border={`1px solid ${colors.gray50}`}
        borderRadius={"4px"}
      />
    </Wrapper>
  );
};

export default PasswordInput;
